module.exports = __webpack_public_path__ + "img/sozialschnellgut_2_a.fd26b533.jpg";